<template>
  <nav>
    <template v-if="step > 1">
      <button class="btn inverse" v-on:click="goto(step-1)">{{ 'buttons.back' | trans }}</button>
      <button class="arrow prev" v-on:click="goto(step-1)"> </button>
    </template>
    <template v-if="step < lastvalid">
      <button class="btn" v-on:click="goto(step+1)" :disabled="!pagevalid[step-1]">{{ 'buttons.next' | trans }}</button>
      <button class="arrow next" v-on:click="goto(step+1)" :disabled="!pagevalid[step-1]"> </button>
    </template>
    <template v-if="step === lastvalid">
      <button class="btn" v-on:click="submit" :disabled="!pagevalid[step-1]"><slot /></button>
    </template>
  </nav>
</template>

<script>
  export default {
    name: 'PrevNext',
    props: ['step', 'steps', 'pagevalid'],
    computed: {
      lastvalid () {
        for (let i = this.steps.length; i > 0; i--) {
          if (this.steps[i-1]) {
            return i;
          }
        }
      },
    },
    methods: {
      getParentProp (value) {
        var parent = this.$parent;
        for (let i = 0; i < 10; i++) {
          if (parent && parent.hasOwnProperty(value)) {
            return parent[value];
          }
          parent = parent.$parent;
        }
      },
      goto (step) {
        return this.getParentProp('goto')(step);
      },
      submit () {
        return this.getParentProp('submit')();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/helpers/mixins/steps/PrevNext.vue